import React, { forwardRef, useEffect, useMemo, useRef, useState } from "react";
// eslint-disable-next-line no-unused-vars
import PropTypes from "prop-types";

import Container from "../Container";
import useGames from "./useGames";
import { go } from "../../classes/routesLazy";
import { gameNameNormalized } from "../../classes/utills";
import { useSelector } from "react-redux";
import Loader from "../../components/loader/Loader";
import Input from "../../components/input/Input";
import lang from "../../classes/lang";

const FlappyBet = forwardRef(() => {
	FlappyBet.propTypes = {};
	const me = useSelector((store) => store.player.uid);
	const initFinished = useSelector((store) => store.initFinished);
	const coinSelected = useSelector((store) => store.coin.selected);
	const flappySessions = useSelector((store) => store.flappySessions);
	const { games, getGames } = useGames({ coinSelected });
	const [search, setSearch] = useState("");

	useEffect(() => {
		getGames();
	}, []);

	//client side filter by name part or id:
	const filtered = useMemo(() => {
		const q = search.trim().toLowerCase();
		if (!q) return games;
		return games.filter((el) => `${el.Name}`.toLowerCase().includes(q) || `${el.Id}`.includes(q));
	}, [games, search]);

	const onGameClick = async (el) => {
		const isDemo = me === -1 ? true : false;
		go(`originals/${gameNameNormalized(el.Name.toLowerCase())}/${el.Id}/${isDemo ? "demo" : "real"}`);
	};

	const imgWrapperRef = useRef();
	const inDepBonus = useSelector((store) => (store.playerConfig || {}).depBonus?.active === true);
	return (
		<Container className="flappyBet">
			<>
				<div className="slotSearch">
					<Input
						className="inpGameSearch"
						placeholder={lang.translate("search_game")}
						type="text"
						name="flappyGame"
						value={search}
						onChange={(e) => setSearch(e.target.value)}
					/>
				</div>
				{initFinished ? (
					<div className="gamelist">
						{filtered.map((el) => {
							return (
								<div onClick={(e) => [e.stopPropagation(), onGameClick(el)]} className="game slotGameSlide" key={el.Id}>
									<div className="counter">
										<img src="/assets/player.svg" alt="" title="" />
										<b>{flappySessions.find((s) => s.GameId === el.Id)?.N ?? 0}</b>
									</div>
									<div className="bg">
										<div ref={imgWrapperRef} className="imgWrapper">
											<img
												className="loading"
												src={el.Image} //add q_auto
												onLoad={(el) => [(el.target.className = "loaded"), (imgWrapperRef.current.className += " loaded")]}
												alt=""
												title=""
											/>
										</div>
									</div>
									<div className="content">
										<div className="buttons">
											<button onClick={(e) => [e.stopPropagation(), onGameClick(el)]} className="btnPlaySvg">
												<svg className="play-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 63 63">
													<defs></defs>
													<g fill="none" fillRule="evenodd">
														<circle cx="31.3" cy="31.3" r="30.3" fill="#000" fillOpacity=".2" stroke="#E5E7EE" strokeWidth="2"></circle>
														<path fill="#F5F6F7" d="M39.5 34.3l-11.3 7.5a2 2 0 01-3-1.6v-15a2 2 0 013-1.7L39.5 31a2 2 0 010 3.3z"></path>
													</g>
												</svg>
											</button>
										</div>
										<h3>
											<b>{el.Name}</b>
										</h3>
										<div className="providerCap">
											<b>FlappyBet</b>
											{inDepBonus && <b className="green">incl.1/3</b>}
										</div>
									</div>
								</div>
							);
						})}
					</div>
				) : (
					<Loader />
				)}
			</>
		</Container>
	);
});

FlappyBet.displayName = "FlappyBet";

export default FlappyBet;
